import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
// material
import { alpha, styled } from '@mui/material/styles';
import { AppBar, Toolbar, IconButton, Box, Stack } from '@mui/material';
// components
import Iconify from '../../components/Iconify';
//
import ThemeSelector from './ThemeSelector';
import LanguageSelector from './LanguageSelector';
import { useIdle } from '../../contexts/IdleContext';

const DRAWER_WIDTH = 280;

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

Navbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function Navbar({ onOpenSidebar }) {
  const { pathname } = useLocation();
  const { countdown } = useIdle();
  const ischatroom = (pathname === '/chatroom').toString();

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;
  // User literally asked for "mm::ss" format
  const timeStr = `${minutes.toString().padStart(2, '0')}::${seconds.toString().padStart(2, '0')}`;

  return (
    <AppBar className={`navbar-root ${ischatroom === 'true' ? 'navbar--chatroom' : ''}`}>
      <Toolbar className="navbar-toolbar">
        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary', display: { lg: ischatroom?'block':'none' }, pointerEvents: 'auto' }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={1} sx={{ pointerEvents: 'auto' }}>
          <Box sx={{ color: 'text.secondary', fontWeight: 'bold', mr: 1, fontSize: '0.875rem', fontFamily: 'monospace' }}>
            {timeStr}
          </Box>
          <LanguageSelector />
          <ThemeSelector />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
